import { useId } from "react";
import { StepperInput } from "./StepperInput";
import {
  FieldPairAside,
  FieldPairRow,
  FormGroup,
  FormSection,
  HelpText,
  Input,
  Label,
  SectionTitle,
} from "./styles";

interface AnthropicFieldsProps {
  apiKey: string;
  setApiKey: (value: string) => void;
  model: string;
  setModel: (value: string) => void;
  maxTokens: string;
  setMaxTokens: (value: string) => void;
}

export function AnthropicFields({
  apiKey,
  setApiKey,
  model,
  setModel,
  maxTokens,
  setMaxTokens,
}: AnthropicFieldsProps) {
  const apiKeyId = useId();
  const modelId = useId();
  const maxTokensId = useId();

  return (
    <FormSection>
      <SectionTitle>Anthropic configuration</SectionTitle>

      <FormGroup>
        <Label htmlFor={apiKeyId}>API key*</Label>
        <Input
          id={apiKeyId}
          type="password"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          placeholder="sk-ant..."
          required
        />
        <HelpText>Your Anthropic API key</HelpText>
      </FormGroup>

      {/* Model + Max tokens share one row per Figma 14063-32375: the model
          stretches, the tokens keep the fixed aside width. */}
      <FieldPairRow>
        <FormGroup>
          <Label htmlFor={modelId}>Model</Label>
          <Input
            id={modelId}
            type="text"
            value={model}
            onChange={(e) => setModel(e.target.value)}
            placeholder="claude-sonnet-4-6"
          />
          <HelpText>Leave empty for default (claude-sonnet-4-6).</HelpText>
        </FormGroup>

        <FieldPairAside>
          <Label htmlFor={maxTokensId}>Max tokens</Label>
          <StepperInput
            id={maxTokensId}
            label="max tokens"
            value={maxTokens}
            onChange={setMaxTokens}
            placeholder="64000"
          />
          <HelpText>Leave empty for default (64000).</HelpText>
        </FieldPairAside>
      </FieldPairRow>
    </FormSection>
  );
}
